import { useNoOrgExperience } from '@townsquare/org-context';
import { createRouterSelector } from '@townsquare/router/createRouterSelector';
import { matchRoute } from '@townsquare/router/primitives/match-route';
import { HomepageRoute, HomepageRouteType } from '@townsquare/router/route-types';
import { chatRoute } from '@townsquare/routes/chat';
import { rovoSearchRoute } from '@townsquare/routes/rovo-search-view';
import { searchRoute } from '@townsquare/routes/search';
import { useNoWorkspaceExperience } from '@townsquare/workspace-store';

import { noWorkspaceRoutes, routes } from './routes';

export const useRoute: (args_0: void) => HomepageRoute = createRouterSelector<HomepageRoute>(
	(o) => o.route as HomepageRoute,
);

export const useHomeRoutes = (): HomepageRouteType[] => {
	const noOrgExperience = useNoOrgExperience();
	const noWorkspaceExperience = useNoWorkspaceExperience();
	return noOrgExperience || noWorkspaceExperience ? noWorkspaceRoutes : routes;
};

export const useIsOnFullscreenChat = (): boolean | null => {
	const matchedRoute = matchRoute(routes, window.location.pathname);
	return matchedRoute && matchedRoute.route?.name === chatRoute.name;
};

export function useIsOnFullscreenSearch(): boolean {
	const matchedRoute = matchRoute(routes, window.location.pathname);

	return matchedRoute?.route?.name === searchRoute.name;
}

export function useIsOnRovoSearch(): boolean {
	const matchedRoute = matchRoute(routes, window.location.pathname);

	return matchedRoute?.route?.name === rovoSearchRoute.name;
}
